import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useTaskContext } from "../context/TaskContext";

const CreateListModal = ({
  isOpen,
  onRequestClose,
  listToEdit,  // { name, color }
  projectId,
  customStyles2,
}) => {
  const { createOrUpdateList } = useTaskContext();

  const [newListName, setNewListName] = useState("");
  const [selectedColor, setSelectedColor] = useState("#ffffff");

  useEffect(() => {
    if (listToEdit) {
      setNewListName(listToEdit.name);
      setSelectedColor(listToEdit.color || "#ffffff");
    } else {
      setNewListName("");
      setSelectedColor("#ffffff");
    }
  }, [listToEdit]);

  const handleAddOrUpdateList = async () => {
    if (!newListName.trim()) {
      alert("El nombre de la lista no puede estar vacío.");
      return;
    }
    if (!projectId) {
      alert("No se encontró projectId del proyecto");
      return;
    }
    await createOrUpdateList({
      name: newListName.trim(),
      color: selectedColor,
      projectId,
      oldName: listToEdit?.name || null,
    });
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles2}
      contentLabel={listToEdit ? "Editar Lista" : "Agregar Lista"}
    >
      <button onClick={onRequestClose} className="modal-close">
        <i className="bi bi-x-lg"></i>
      </button>
      <h2 style={{ textAlign: "center" }}>
        {listToEdit ? "Editar Lista" : "Agregar Lista"}
      </h2>

      <div style={customStyles2.inputContainer}>
        <label style={customStyles2.label}>
          Nombre de la Lista:
          <input
            type="text"
            style={customStyles2.input}
            placeholder="Nombre de la lista"
            value={newListName}
            onChange={(e) => setNewListName(e.target.value)}
          />
        </label>
        <label style={customStyles2.label}>
          Color:
          <input
            type="color"
            style={customStyles2.inputColor}
            value={selectedColor}
            onChange={(e) => setSelectedColor(e.target.value)}
          />
        </label>
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={handleAddOrUpdateList}
          style={customStyles2.addButton}
        >
          {listToEdit ? "Actualizar Lista" : "Guardar Lista"}
        </button>
      </div>
    </Modal>
  );
};

export default CreateListModal;
